module.exports = __webpack_public_path__ + "img/gf.34d3a13f.svg";